export default __webpack_public_path__ + "static/media/home_thumb_eos.49cd9619.png";